import { Dispatch, SetStateAction } from "react";

import { MerchantAccount } from "@hz/common/google/types";

import { Combobox } from "@components/combobox";
import { Field } from "@components/ui/field";

type Options = {
  id: string;
  description: string;
};

type SelectCurrencyProps = {
  initialId?: { id: string; description: string };
  setValue: (value: string) => void;
  isDisabled?: boolean;
  invalid?: boolean;
  options: Options[];
};

const SelectMerchantId = ({
  initialId,
  setValue,
  options,
  isDisabled = false,
  invalid = false,
}: SelectCurrencyProps) => {
  return (
    <Field
      label="Select GMC Merchant Account"
      invalid={invalid}
      disabled={isDisabled}
    >
      <Combobox<Options>
        size="sm"
        defaultValue={initialId}
        options={options as Array<Options>}
        getOptionLabel={(x) => `${x.id} (${x.description})`}
        renderOption={(x) => (
          <>
            {x.id} ({x.description})
          </>
        )}
        placeholder="Choose from dropdown..."
        onSelect={(value) => {
          if (value) {
            setValue(value.id);
          }
        }}
        isDisabled={isDisabled}
      />
    </Field>
  );
};

export default SelectMerchantId;
